import { createI18n } from 'vue-i18n'

let _i18n = null
export const getI18n = () => {
  if (_i18n === null) {
    _i18n = createI18n({
      legacy: false,
      locale: 'en',
      fallbackLocale: 'en',
      messages: { en: {} },
    })
  }

  return _i18n
}
export default function (app) {
  app.use(getI18n())
}
